import { addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';

import { setTranslations as setNavTranslations } from '@99designs/globalnav/locale-data';
import navDe from '@99designs/globalnav/locale-data/de';

setNavTranslations(navDe);
addLocaleData(de);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/de.js